const ShopApiUrl = 'https://souliersmartinez.myshopify.com/api/graphql';
const ShopApiToken = '8b3f1604538bc32ba810fb6061ef42b6';
const ShopFileUrl = 'https://cdn.shopify.com/s/files/1/2618/6980/files/';

function searchProductsByTitle(elem) {
  let myTitle = elem.data('product-title');
  let myHandle = elem.data('product-handle');

  if (myTitle != '') {
    $.ajax({
      url: ShopApiUrl,
      method: 'POST',
      headers: {
          'X-Shopify-Storefront-Access-Token': ShopApiToken,
          'Content-Type': 'application/graphql',
      },
      data: `query {
        products(first:100, query: "title:` + myTitle + ` - *"){
          edges {
            node {
              id
              title
              handle
              images(first:1) {
                edges {
                  node {
                    id
                    url
                  }
                }
              }
              metafield0: metafield(key:"color2", namespace:"my_fields"){
                value
              }
              metafield1: metafield(key:"color", namespace:"my_fields"){
                value
                reference {
                  ... on MediaImage {
                    id
                    image {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }`,
    })
    .done(function(data) {
      if (!data.data.products) {
        elem.remove();
      } else {
        elem.find('.color-selector a').remove();
        
        var edges = data.data.products.edges;
        var j, id, shopifyId, product, title, handle, mColoris, mCouleur, color_handle, sHtmlMeta, sHtmlClass, mImage;
        
        for (var i=0; i<edges.length; i++) {
          product = edges[i].node;
          shopifyId = product.id;
          id = shopifyId.split('/').pop();
          title = product.title;
          handle = product.handle;

          if (handle)
          {
            sHtmlMeta = sHtmlMeta2 = sHtmlClass = mImage = mColor = sUrlImage = pImageUrl = '';
  
            if (product.metafield0) mColor = product.metafield0.value;
            if (product.metafield1) mImage = product.metafield1.value;
            if (product.images) pImageUrl = product.images.edges[0].node.url;
  
            sHtmlMeta = 'data-product-id="' + id + '"' + (pImageUrl != '' ? ' data-hover="' + pImageUrl.replace('.jpg', '_600x.jpg') + '"' : '');
            if (mColor != '') {
              sHtmlMeta2 = 'style="background-color:' + mColor + '"';
            } else if (mImage != '') {
              sHtmlClass = ' load-color-image';
              if (product.metafield1.reference) src = product.metafield1.reference.image.url;
              sHtmlMeta2 = 'style="background-image:url(\'' + src + '\')"';
            } else {
              sHtmlMeta2 = 'style="background-color:#ddd"';
            }
  
            elem.find('.color-selector').append('<a href="/products/' + handle + '" class="color-variant' + sHtmlClass + (handle == myHandle ? ' on' : '') + '" title="' + title + '" ' + sHtmlMeta + '><span ' + sHtmlMeta2 + '></span></a>');
          }
        }
    
        $('.color-swatches[data-product-handle="' + handle + '"]:not(.ready)').each(function(){
          $(this).html(elem.html());
          $(this).addClass('ready').show();
        });
      }
  
      elem.addClass('ready').show();
      if (elem.closest('.ProductItem').length > 0) loopSearchProductsByTitle();

      addThumbCmd(elem);
    });
  } else {
    elem.addClass('ready').show();
    if (elem.closest('.ProductItem').length > 0) loopSearchProductsByTitle();
  }
}

function loopSearchProductsByTitle() {
  let elem = $('.color-swatches:not(.ready):eq(0)');
  if (elem.length > 0) searchProductsByTitle(elem);
}
function addThumbCmd(elem) {
  elem.find('.links a').mouseenter(function(e){
    var img = $(this).data('hover');
    console.log(img);
    $(this).closest('.ProductItem__Wrapper').find('.ProductItem__ImageWrapper').append('<img src="' + img + '" class="swatches-hover" />');
  });
  elem.find('.links').mouseleave(function(e){
    $(this).closest('.ProductItem__Wrapper').find('.ProductItem__ImageWrapper .swatches-hover').remove();
  });
}

$(document).ready(function(){
  loopSearchProductsByTitle();
});